import { useRef, useEffect } from 'react'

export const useScrollTo = (elementId: string, options?: ScrollToOptions) => {
  const elementRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const element = document.getElementById(elementId)

    if (element) {
      elementRef.current = element

      const handleScrollTo = () => {
        if (elementRef.current) {
          elementRef.current.scrollIntoView(options)
        }
      }

      handleScrollTo() // Trigger initial scroll when the component mounts

      return () => {
        elementRef.current = null
      }
    }
  }, [elementId, options])

  // Usage
  //   const targetElementRef = useScrollTo('targetElementId', { behavior: 'smooth' })

  //   const handleClick = () => {
  //     // You can use the targetElementRef to scroll to the element
  //     if (targetElementRef.current) {
  //       targetElementRef.current.scrollIntoView({ behavior: 'smooth' })
  //     }
  //   }

  //   return (
  //     <div>
  //       {/* Your content */}
  //       <button onClick={handleClick}>Scroll to Target Element</button>
  //       <div id="targetElementId">Target Element</div>
  //       {/* More content */}
  //     </div>
  //   )

  return elementRef
}
